import React from 'react';
import PreLoader from './Components/Common/PreLoader';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Components/Common/Header';
import Footer from './Components/Common/Footer';
import Contact from './Pages/Contact/Contact';
import PropertyDetails from './Pages/PropertyDetails/PropertyDetails';
import Properties from './Pages/PropertiesList/Properties'
import Version2 from './Pages/Version2/Version2'
import FooterHead from './Components/Common/FooterHead';
import Faq from './Pages/Faqs/Faq'
import TermsAndConditions from './Pages/Terms/TermsandConditions';
import Privacypolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import ProgressBar from './Components/Common/ProgressBar';
import ErrorMessage from './Components/Common/ErrorMessage';
import ChannelPartner from './Pages/ChannelPartner/ChannelPartner';


function App() {
 
  return (
    <>
      <Router>
      <Header />
      <PreLoader/>
      <ProgressBar/>
        <Routes>
        <Route path="/" element={<Version2/>} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/property-details/:property_id" element={<PropertyDetails/>} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<Privacypolicy/>} />
        <Route path="/refund-policy" element={<Privacypolicy/>} />
        <Route path="/errorMessage" element={<ErrorMessage />} />
        <Route path="/channelpartner" element={<ChannelPartner />} />

        </Routes>
        <FooterHead />
        <Footer />
      </Router>
    </>
  );
}

export default App;
